module.exports = __webpack_public_path__ + "img/historisch.5216ef97.jpg";